import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { TooltipModule } from 'primeng/tooltip';
import { PermissionAction } from '@app/features/dashboard/group-register/permission-tree/permission-tree.models';
import { splitHighlight } from '@app/features/dashboard/group-register/permission-tree/permission-selection.utils';

/** Uma ação com a chave de ligar/desligar. O código técnico só aparece no tooltip do ícone de informação. */
@Component({
  selector: 'app-permission-action-row',
  standalone: true,
  imports: [SharedModule, TooltipModule],
  templateUrl: './permission-action-row.component.html',
  styleUrls: ['./permission-action-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionActionRowComponent {
  readonly action = input.required<PermissionAction>();
  readonly checked = input(false);
  /** Mostra de qual grupo a ação é quando a tela junta mais de um grupo ("Comitê de risco"). */
  readonly showGroup = input(false);
  /** Selo de Leitura/Gravação, usado nos resultados da busca. */
  readonly showKind = input(false);
  /** A ação mudou em relação ao que está salvo. */
  readonly changed = input(false);
  /** Termo da busca, destacado no rótulo. */
  readonly query = input('');

  readonly checkedChange = output<boolean>();

  readonly kindLabel = computed(() => {
    const kind = this.action().kind;
    return kind === 'write' ? 'Gravação' : kind === 'menu' ? 'Menu' : 'Leitura';
  });

  readonly labelParts = computed(() => splitHighlight(this.action().label, this.query()));

  readonly hintText = computed(() =>
    this.showGroup() ? this.action().groupLabel : this.action().hint
  );

  readonly codeTooltip = computed(() => `Código: ${this.action().value}`);
}
